import { assignJob, getFreePopulation, MAX_GOLD_MINERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireGoldMinerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.goldMine.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_GOLD_MINERS * settlement.buildings.goldMine.qty;
    if (settlement.jobs.goldMiners >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'goldMiners')) return false;
    settlement.production.goldMine.progress.push(0);
    return true;
};
